import { render } from "./firmManagerShow.vue?vue&type=template&id=627ebd22"
import script from "./firmManagerShow.vue?vue&type=script&lang=js"
export * from "./firmManagerShow.vue?vue&type=script&lang=js"

import "./firmManagerShow.vue?vue&type=style&index=0&id=627ebd22&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__